import React from 'react';
export const NotFoundPage = () => {
   return (
     <div>
       <h1>404 - Strony nie znaleziono</h1>
     </div>
   );
 };